import styled from 'styled-components'

const InputContainer = styled.div`
  flex: 1;
`

export default InputContainer
